<div id="e-resources" class="watermark">
  <div class="container-fluid px-lg-5 py-4">
    <div class="row">
      <div class="col-12 text-center">
        <h2 class="title mb-4">E-Resources</h2>
      </div>

      <div class="col-12">
        <p class="inner-lead">
          <strong>N-List</strong> (National Library and Information Services Infrastructure for Scholarly Content):
        </p>

        <ul class="inner-lead">
          <li>
            Access to e-books and e-journals. Ask your college library for user ID and Password to access N-LIST resources.
          </li>
          <li>
            Link :
            <a href="https://nlist.inflibnet.ac.in/" target="_blank">Click for the link</a>
          </li>
        </ul>

        <h5 class="mt-3" style="color: var(--orange); font-weight: 700;">N-LIST</h5>

        <div class="text-center my-3">
          <img
            src="/assets/img/library/nlist-login.png"
            alt="N-LIST Login Window"
            class="page-img"
          />
        </div>

        <p class="inner-lead fw-bold mt-4">Online Certificate Courses</p>
        <ol class="inner-lead">
          <li>
            <strong>Swayam Portal</strong> –
            <a href="https://swayam.gov.in/" target="_blank">Click for the link</a>
          </li>
        </ol>

        <p class="inner-lead fw-bold mt-4">Open Access</p>
        <ol class="inner-lead">
          <li>
            <strong>DOAJ (Directory of Open Access Journals):</strong>
            <a href="https://doaj.org/" target="_blank">Click for the link</a>
          </li>
          <li>
            <strong>DOAB (Directory of Open Access Books):</strong>
            <a href="https://www.doabooks.org/" target="_blank">Click for the link</a>
          </li>
          <li>
            <strong>National Digital Library of India:</strong>
            <a href="https://ndl.iitkgp.ac.in/" target="_blank">Click for the link</a>
          </li>
          <li>
            <strong>e-PG Pathshala – E-contents for PG Courses:</strong>
            <a href="https://epgp.inflibnet.ac.in/" target="_blank">Click for the link</a>
          </li>
          <li>
            <strong>Various Competitive Exams:</strong>
            <a href="https://www.ncs.gov.in/" target="_blank">Click for the link</a>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
